<div class="sb-card-wrapper">
  <div class="sb-card">
    <div class="sb-card-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
